import { FC } from 'react';
import { Box, Grid, Spacer } from '@wegroup/design-system';
import LanguageChangeMenu from '@flows/src/components/ui/advisory-flow/components/LanguageChangeMenu';
import Avatar from '@sales-conversation/src/components/default/ProdFacAvatar';

const FlowsConfigMobileToolbar: FC = () => {
  return (
    <Grid
      alignItems="center"
      gridGap="4"
      templateColumns={{
        base: '1fr auto',
        mobileM: '4.4rem 1fr auto',
      }}
    >
      <Box display={{ base: 'none', mobileM: 'block' }}>
        <Avatar />
      </Box>
      <Spacer />
      <LanguageChangeMenu />
    </Grid>
  );
};

export default FlowsConfigMobileToolbar;
